import { EItemType, IChatData, IFeedItem } from '.';

export enum NpcTagType {
  NpcNormalTag = 1,
  NpcStyleTag = 2,
}

export interface TagColorStyle {
  color: string;
  alpha: number;
}

export interface TagElemStyle {
  icon_url: string;
  border_color: TagColorStyle;
}

export enum H5TagType {
  H5NormalTag = 1, // h5普通标签
  H5ActivityTag = 2, // h5运营配置的标签
}

export interface NpcTagH5Info {
  h5_tag_type: H5TagType;
  connectors: number;
  participants: number;
  description: string;
  introduction_url: string;
  banner_url: string;
  theme_color: string;
  tag_prompt: string; // 标签带的prompt
}

export interface ITagInfo {
  tag_name?: string;
  npc_tag_type?: NpcTagType;
  tag_id?: number;
  tag_style?: TagElemStyle;
  tag_schema_url?: string;
  npc_tag_h5_info?: NpcTagH5Info;
}

export interface IPostGetTagInfoByIDReq {
  npc_tag_id_list: number[];
}

export interface IPostGetTagInfoByIDResp {
  npc_tag_list: ITagInfo[];
}

export interface IPostSearchNpcByTagReq {
  npc_tag_id: number;
  npc_tag_name?: string;
  page?: number;
  size?: number;
}

export interface IPostSearchNpcByTagResp {
  item_list: IFeedItem[];
  has_more: boolean;
}

export interface ISearchLandingPageItem {
  item_list?: IFeedItem[];
  npc_tag?: ITagInfo;
  item_type?: EItemType;
}

export enum SearchLandingPageScene {
  Default = 0, // 客户端上现有的行为，默认返回当前页全量tag+对应npc
  TalkieWebExplore = 1, // talkie web端上，explore 页面的请求
}

export interface ISearchLandingPageReq {
  page?: number;
  size?: number;
  scene?: SearchLandingPageScene;
  tag_id?: number;
  web_language?: string; // 多语言
}

export interface ISearchLandingPageResp {
  item_list?: ISearchLandingPageItem[];
  has_more?: boolean;
}

export interface ISearchQueryReq {
  query: string;
  page: number;
  size?: number;
  is_final_query?: boolean;
  trace_info_str?: string; // map[string]string序列化后的结果
}

export interface ISearchQueryItem {
  item_type: EItemType;
  chat_data?: IChatData;
  search_landing_page_item?: ISearchLandingPageItem;
  trace_info_str?: string;
}

export interface ISearchQueryResp {
  item_list: ISearchQueryItem[];
  has_more?: boolean;
}

export enum PcSearchRecommendScene {
  for_you = 1, // pc web头顶的for you
}

export interface IPcSearchRecommendReq {
  scene: PcSearchRecommendScene;
}

export interface IPcSearchRecommendResp {
  item_list?: IFeedItem[];
}

export interface IPcSearchLandingPageReq {
  tag_id?: number;
  page: number;
  size: number;
}

export interface PcSearchTag {
  title: string;
  tag_id: number;
  sub_tag: PcSearchTag[];
  default_selected?: boolean;
}

export interface IPcSearchLandingPageResp {
  tag_list: PcSearchTag[];
  item_list: IFeedItem[];
  has_more?: boolean;
}
